import React from 'react';
import axios from 'axios';
import 'react-table/react-table.css';
import Pagination from 'react-js-pagination';
import { LinearProgress } from 'react-md';
import '../../../node_modules/react-md/dist/react-md.indigo-blue.min.css';
import 'bootstrap-datepicker/js/bootstrap-datepicker.js';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css';
import ViewModal from './_modal/view';
import Loader from '../../_components/loader';
import { NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import { AdminUrls } from '../../network/config';
import './style.css';
import { connect } from 'react-redux';
import { removeData } from '../../store/action';

const moment = require('moment');

const Cpd_Url = AdminUrls.COMMON.CPDTYPE;
const LoadHost_Url = AdminUrls.COMMON.LOADHOST;
const MyCPDReport_URL = AdminUrls.COMMON.CPDLIBRARYEXCEL;
const cpd_Format_Url = AdminUrls.COMMON.CPDFORMAT;
const get_Course_Url = AdminUrls.COMMON.GETCOURSEFILE;
const course_Location_Url = AdminUrls.COMMON.COURSELOCATION;
const Library_Url = AdminUrls.ADMIN.CPDADMIN;
const Update_Url = AdminUrls.ADMIN.CPDADMINUPDATECOURSE;
const cpd_addCourse = AdminUrls.ADMIN.CPDADMINADDCOURSE;
const upload_Course_Url = AdminUrls.ADMIN.COURSEFILE;
const delete_Url = AdminUrls.ADMIN.DELETECOURSE;
const downloadFile_Url = AdminUrls.COMMON.COURSEFILEDOWNLOAD;

class AdminDash extends React.Component {
  constructor(props) {
    super(props);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.clearSearchFilters = this.clearSearchFilters.bind(this);
    this.searchData = this.searchData.bind(this);
    this.downloadExcel = this.downloadExcel.bind(this);
    this.archiveCourse = this.archiveCourse.bind(this);
    this.modalData = this.modalData.bind(this);
    this.handleCpdMinutesChange = this.handleCpdMinutesChange.bind(this);
    this.editCourse = this.editCourse.bind(this);

    this.handleTitleChange = this.handleTitleChange.bind(this);
    this.handleDescChange = this.handleDescChange.bind(this);
    this.handleLocChange = this.handleLocChange.bind(this);
    this.handleVenueChange = this.handleVenueChange.bind(this);
    this.handleTypeChange = this.handleTypeChange.bind(this);
    this.handleFormatChange = this.handleFormatChange.bind(this);
    this.handleHostChange = this.handleHostChange.bind(this);
    this.handleTrainerChange = this.handleTrainerChange.bind(this);
    this.handleSurveyLinkChange = this.handleSurveyLinkChange.bind(this);
    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.handleCpdHourChange = this.handleCpdHourChange.bind(this);
    this.handleCourseBookChange = this.handleCourseBookChange.bind(this);
    this.handleAddData = this.handleAddData.bind(this);
    this.handleSwitchButton = this.handleSwitchButton.bind(this);
    this.getFormatLocData = this.getFormatLocData.bind(this);
    this.handleUpdateData = this.handleUpdateData.bind(this);
    this.handleUploadFile = this.handleUploadFile.bind(this);
    this.handleDeleteFile = this.handleDeleteFile.bind(this);
    this.handleDownloadFile = this.handleDownloadFile.bind(this);
    this.pdfDownload = this.pdfDownload.bind(this);
    this.handlePaymentNeededChange = this.handlePaymentNeededChange.bind(this);
    this.state = {
      listViewModalShown: false,
      totalPages: 0,
      totalCount: 0,
      per_page: 10,
      activePage: 0,
      cpdType: '',
      loadHost: '',
      libraryData: [],
      sort: {
        column: 'StartDate',
        direction: 'desc',
      },
      course_name: '',
      location_name: '',
      cpd_type: '',
      start_date: '',
      host_name: '',
      cpd_format: '',
      course_Location: '',
      switchCheck: false,
      mainLoading: false,

      file: '',
      listViewDataCoursetitle: '',
      listViewDataCoursedesc: '',
      listViewDataCourselocation: '',
      listViewDataCoursevenue: '',
      listViewDataCoursetype: '',
      listViewDataCourseformat: '',
      listViewDataCoursehost: '',
      listViewDataCoursetrainer: '',
      listViewDataSurveyLink: '',
      listViewDataCoursestartdate: '',
      listViewDataCoursecpdhours: '',
      listViewDataCoursehowtobook: '',
      listViewDataCoursecpdMinutes: '',
      listViewAdminOnly: false,
      listViewInHouseOnly: false,
      addEditCourseBtn: false,
      editId: '',
      fileData: [],
      emptyDivMsg: 'There is no data to show in the grid.',
      titlemodal: '',
      listViewDataPaymentNeeded: false,
    };
    this.controller = new AbortController();
  }

  downloadExcel() {
    var fileType = 'application/vnd.ms-excel';
    var name;
    this.setState({ mainLoading: true });
    axios(MyCPDReport_URL, {
      responseType: 'blob',
      method: 'GET',
      signal: this.controller.signal,
      withCredentials: true,
      credentials: 'include',
      headers: {
        Authorization:
          `${this.props.user.token_type} ` + this.props.user.access_token,
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        var blob = new Blob([response.data], { type: fileType });

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, name);
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'Library.xlsx');
          document.body.appendChild(link);
          link.click();
        }
        this.setState({ mainLoading: false });
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  handlePageChange(pageNumber) {
    this.setState({
      mainLoading: true,
    });
    let CPDTypeId = this.state.cpd_type;
    let CourseName = this.state.course_name;
    let HostId = this.state.host_name;
    let LocationName = this.state.location_name;
    if (CPDTypeId === '') {
      CPDTypeId = '';
    } else {
      CPDTypeId = 'CPDTypeId=' + this.state.cpd_type;
    }

    if (CourseName === '') {
      CourseName = '';
    } else {
      CourseName = 'CourseName=' + this.state.course_name;
    }
    if (HostId === '') {
      HostId = '';
    } else {
      HostId = 'HostId=' + this.state.host_name;
    }
    if (LocationName === '') {
      LocationName = '';
    } else {
      LocationName = 'LocationName=' + this.state.location_name;
    }

    this.setState({
      activePage: pageNumber,
    });
    this.getLibraryData(
      pageNumber,
      CPDTypeId,
      CourseName,
      HostId,
      LocationName
    );
  }
  componentDidMount() {
    this.getCpdType();
    this.getLoadCpd();
  }
  pdfDownload() {
    var fileType = 'application/pdf';
    this.setState({ mainLoading: true });

    var blob = new Blob(this?.state?.libraryData, { type: fileType });

    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob);
    } else {
      const url = window.URL.createObjectURL(
        new Blob(this?.state?.libraryData, { type: fileType })
      );
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Admin-Lib');
      document.body.appendChild(link);
      link.click();
      this.setState({ mainLoading: false });
    }
  }

  getCpdType() {
    axios
      .get(Cpd_Url, {
        method: 'GET',
        signal: this.controller.signal,
        withCredentials: true,
        credentials: 'include',
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => response.data)
      .then((data) => {
        this.setState({
          cpdType: data,
        });
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  // Get CPD
  getLoadCpd() {
    this.setState({ mainLoading: true });

    axios
      .get(LoadHost_Url, {
        method: 'GET',
        signal: this.controller.signal,
        withCredentials: true,
        credentials: 'include',
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => response.data)
      .then((data) => {
        this.setState({
          loadHost: data,
          mainLoading: false,
        });

        this.getLibraryData(1, '', '', '', '');
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  // Get Library Data From Api
  getLibraryData(
    pages,
    CPDTypeId,
    CourseName,
    HostId,
    LocationName,
    column,
    direction
  ) {
    this.setState({
      mainLoading: true,
    });

    let startDate = this.state.start_date;
    let reverse = this.state.sort.direction;
    let sortBy = this.state.sort.column;
    if (column) {
      sortBy = column;
    }

    if (direction) {
      reverse = direction;
    }
    reverse = reverse === 'asc' ? false : true;
    let obj = {
      page: pages,
      pageSize: this.state.per_page,
      reverse: reverse,
      sortBy: sortBy,
    };

    if (CPDTypeId) {
      obj.CPDTypeId = CPDTypeId;
    }
    if (CourseName) {
      obj.CourseName = CourseName;
    }
    if (HostId) {
      obj.HostId = HostId;
    }
    if (LocationName) {
      obj.LocationName = LocationName;
    }
    if (startDate) {
      obj.StartDate = moment(startDate).format('ll');
    }

    axios
      .get(Library_Url, {
        params: obj,
        method: 'GET',
        signal: this.controller.signal,
        withCredentials: true,
        credentials: 'include',
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => response.data)
      .then((data) => {
        let _data = data?.Items;
        for (let i = 0; i < data?.Items.length; i++) {
          let hostData = this?.state?.loadHost?.find(
            (x) => x.ID === data?.Items[i].HostID
          );
          if (hostData) {
            _data[i].hostName = hostData.Name;
          }
        }

        this.setState({
          libraryData: _data,
          totalPages: data?.TotalPages,
          totalCount: data?.TotalCount,
          activePage: data?.Page,
          mainLoading: false,
        });
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  // Search Data
  searchData() {
    let CPDTypeId = this.state.cpd_type;
    let CourseName = this.state.course_name;
    let HostId = this.state.host_name;
    let LocationName = this.state.location_name;
    let pages = this.state.activePage;

    this.getLibraryData(pages, CPDTypeId, CourseName, HostId, LocationName);
  }

  // Clear Search
  clearSearchFilters() {
    this.setState(
      {
        course_name: '',
        location_name: '',
        cpd_type: '',
        start_date: '',
        host_name: '',
      },
      () => {
        this.getLibraryData(1, '', '', '', '');
      }
    );
  }

  // Archive Course
  archiveCourse(id) {
    let article = {
      Active: false,
      CourseId: id,
    };

    axios
      .post(Update_Url, article, {
        withCredentials: true,
        signal: this.controller.signal,
        credentials: 'include',
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })

      .then((response) => {
        NotificationManager.success(
          response?.data.CourseName,
          'archived Successfully!'
        );

        // let dupData = this.state.libraryData;
        // let filtData = dupData.filter(
        //   (x) => x.CourseId !== response.data.CourseId
        // );
        // this.setState({
        //   libraryData: filtData,
        // });
        this.getLibraryData(this.state.activePage, '', '', '', '');
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  unarchiveCourse(id) {
    let article = {
      Active: true,
      CourseId: id,
    };

    axios
      .post(Update_Url, article, {
        withCredentials: true,
        credentials: 'include',
        signal: this.controller.signal,
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })

      .then((response) => {
        NotificationManager.success(
          response?.data.CourseName,
          'unarchived Successfully!'
        );
        this.getLibraryData(this.state.activePage, '', '', '', '');
        // let dupData = this.state.libraryData;
        // let filtData = dupData.filter(
        //   (x) => x.CourseId !== response.data.CourseId
        // );
        // this.setState({
        //   libraryData: filtData,
        // });
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  getFormatLocData() {
    axios
      .get(cpd_Format_Url, {
        method: 'GET',
        withCredentials: true,
        credentials: 'include',
        signal: this.controller.signal,
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => response.data)
      .then((data) => {
        this.setState({
          cpd_format: data,
        });
        this.setState({
          listViewModalShown: true,
        });
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });

    axios
      .get(course_Location_Url, {
        method: 'GET',
        withCredentials: true,
        credentials: 'include',
        signal: this.controller.signal,
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => response.data)
      .then((data) => {
        this.setState({
          course_Location: data,
        });
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  // Load Apis For Modal Feilds
  modalData() {
    this.setState({
      mainLoading: true,
    });
    this.getFormatLocData();
    this.setState({
      file: '',
      listViewDataCoursetitle: '',
      listViewDataCoursedesc: '',
      listViewDataCourselocation: '',
      listViewDataCoursevenue: '',
      listViewDataCoursetype: '',
      listViewDataCourseformat: '',
      listViewDataCoursehost: '',
      listViewDataCoursetrainer: '',
      listViewDataSurveyLink: '',
      listViewDataCoursestartdate: '',
      listViewDataCoursecpdhours: '',
      listViewDataCoursehowtobook: '',
      listViewDataCoursecpdMinutes: '',
      listViewAdminOnly: false,
      listViewInHouseOnly: false,
      mainLoading: false,
      titlemodal: 'ADD CPD Course',
      addEditCourseBtn: false,
      switchCheck: false,
      paymentneeded: false,
    });
  }
  // Modal Input Onchange Feilds data
  handleTitleChange(e) {
    this.setState({
      listViewDataCoursetitle: e,
    });
  }
  handleDescChange(e) {
    this.setState({
      listViewDataCoursedesc: e,
    });
  }
  handleLocChange(e) {
    this.setState({
      listViewDataCourselocation: e,
    });
  }
  handleVenueChange(e) {
    this.setState({
      listViewDataCoursevenue: e,
    });
  }
  handleTypeChange(e) {
    this.setState({
      listViewDataCoursetype: e,
    });
  }
  handleFormatChange(e) {
    this.setState({
      listViewDataCourseformat: e,
    });
  }
  handleHostChange(e) {
    this.setState({
      listViewDataCoursehost: e,
    });
  }
  handleTrainerChange(e) {
    this.setState({
      listViewDataCoursetrainer: e,
    });
  }
  handleSurveyLinkChange(e) {
    this.setState({
      listViewDataSurveyLink: e,
    });
  }
  handleStartDateChange(e) {
    this.setState({
      listViewDataCoursestartdate: e,
    });
  }
  handleCpdHourChange(e) {
    this.setState({
      listViewDataCoursecpdhours: e,
    });
  }
  handleCourseBookChange(e) {
    this.setState({
      listViewDataCoursehowtobook: e,
    });
  }
  handleCpdMinutesChange(e) {
    this.setState({
      listViewDataCoursecpdMinutes: e,
    });
  }
  handleSwitchButton(e) {
    this.setState({
      switchCheck: e.target.checked,
    });
  }
  handlePaymentNeededChange(e) {
    this.setState({
      listViewDataPaymentNeeded: e,
    });
  }

  // END Modal Input Onchange Feilds data END

  // Add Data From Modal in Api
  handleAddData() {
    if (!this.state.listViewDataCoursetitle) {
      NotificationManager.error(
        'Please use valid information for CourseTitle!'
      );
      return false;
    }

    if (!this.state.listViewDataCoursedesc) {
      NotificationManager.error('Please use valid information for Coursedesc!');
      return false;
    }

    if (!this.state.listViewDataCourselocation) {
      NotificationManager.error(
        'Please use valid information for Courselocation!'
      );
      return false;
    }

    if (!this.state.listViewDataCoursevenue) {
      NotificationManager.error(
        'Please use valid information for Coursevenue!'
      );
      return false;
    }

    if (!this.state.listViewDataCoursetype) {
      NotificationManager.error('Please use valid information for Coursetype!');
      return false;
    }

    if (!this.state.listViewDataCourseformat) {
      NotificationManager.error(
        'Please use valid information for Courseformat!'
      );
      return false;
    }

    if (!this.state.listViewDataCoursehost) {
      NotificationManager.error(
        'Please use valid information for course host!'
      );
      return false;
    }

    if (!this.state.listViewDataCoursestartdate) {
      NotificationManager.error(
        'Please use valid information for course start date!'
      );
      return false;
    }

    if (
      !this.state.listViewDataCoursecpdMinutes &&
      !this.state.listViewDataCoursecpdhours
    ) {
      NotificationManager.error(
        'Please use valid information for CPD hours or minutes!'
      );
      return false;
    }

    this.setState({ mainLoading: true });
    let active = this.state.switchCheck;
    let adminOnly = this.state.listViewAdminOnly;
    let obj = {
      CPDFormatId: +this.state.listViewDataCourseformat,
      CPDTypeId: +this.state.listViewDataCoursetype,
      CourseDescription: this.state.listViewDataCoursedesc,
      CourseName: this.state.listViewDataCoursetitle,
      DurationHours: +this.state.listViewDataCoursecpdhours,
      HostId: +this.state.listViewDataCoursehost,
      HowToBook: this.state.listViewDataCoursehowtobook,
      InHouseOnly: this.state.listViewInHouseOnly,
      LocationId: +this.state.listViewDataCourselocation,
      Minutes: +this.state.listViewDataCoursecpdMinutes,
      StartDate: this.state.listViewDataCoursestartdate,
      Trainer: this.state.listViewDataCoursetrainer,
      SurveyLink: this.state.listViewDataSurveyLink,
      Venue: this.state.listViewDataCoursevenue,
      PaymentNeeded: this.state.listViewDataPaymentNeeded,
    };

    if (active) {
      obj.Active = active;
    }
    if (adminOnly) {
      obj.AdminOnly = adminOnly;
    }

    axios
      .post(cpd_addCourse, obj, {
        withCredentials: true,
        credentials: 'include',
        signal: this.controller.signal,
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })

      .then((response) => {
        NotificationManager.success('Course Added Successfully');
        if (this.state.switchCheck === true) {
          let dupData = this.state.libraryData;
          dupData.push(response?.data);
          this.setState({
            libraryData: dupData,
          });
        }

        this.setState({
          listViewModalShown: false,
          mainLoading: false,
        });
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  editCourse(id) {
    this.getFormatLocData();

    let dupData = this.state.libraryData;
    let i = dupData.findIndex((x) => x.CourseId === id);

    this.setState({
      editId: id,
      switchCheck: dupData[i].Active,
      addEditCourseBtn: true,
      listViewDataCoursetitle: dupData[i].CourseName,
      listViewDataCoursedesc: dupData[i].CourseDescription,
      listViewDataCourselocation: dupData[i].LocationID,
      listViewDataCoursevenue: dupData[i].Venue,
      listViewDataCoursetype: dupData[i].CPDTypeId,
      listViewDataCourseformat: dupData[i].CPDFormatId,
      listViewDataCoursehost: dupData[i].HostID,
      listViewDataCoursetrainer: dupData[i].Trainer,
      listViewDataSurveyLink: dupData[i].SurveyLink,
      listViewDataCoursestartdate: dupData[i].StartDate,
      listViewDataCoursecpdhours: dupData[i].DurationHours,
      listViewDataCoursehowtobook: dupData[i].HowToBook,
      listViewDataCoursecpdMinutes: dupData[i].DurationMins,
      listViewAdminOnly: dupData[i].AdminOnly,
      listViewInHouseOnly: dupData[i].InHouseOnly,
      listViewDataPaymentNeeded: dupData[i].PaymentNeeded,
      titlemodal: 'UPDATE CPD Course',
    });

    axios
      .get(`${get_Course_Url}${'?courseId=' + id}`, {
        method: 'GET',
        withCredentials: true,
        credentials: 'include',
        signal: this.controller.signal,
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        this.setState({
          fileData: response?.data,
        });
      })

      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  handleUpdateData() {
    let obj = {
      Active: this.state.switchCheck,
      AdminOnly: this.state.listViewAdminOnly,
      CPDFormatId: this.state.listViewDataCourseformat,
      CPDTypeId: this.state.listViewDataCoursetype,
      CourseDescription: this.state.listViewDataCoursedesc,
      CourseId: this.state.editId,
      CourseName: this.state.listViewDataCoursetitle,
      CourseType: null,
      DurationHours: this.state.listViewDataCoursecpdhours,
      EmployerId: null,
      HostId: this.state.listViewDataCoursehost,
      HostName: null,
      HowToBook: this.state.listViewDataCoursehowtobook,
      InHouseOnly: this.state.listViewInHouseOnly,
      LocationId: this.state.listViewDataCourselocation,
      LocationName: null,
      Minutes: this.state.listViewDataCoursecpdMinutes,
      StartDate: this.state.listViewDataCoursestartdate,
      Trainer: this.state.listViewDataCoursetrainer,
      SurveyLink: this.state.listViewDataSurveyLink,
      Venue: this.state.listViewDataCoursevenue,
      PaymentNeeded: this.state.listViewDataPaymentNeeded,
    };

    axios
      .post(Update_Url, obj, {
        withCredentials: true,
        credentials: 'include',
        signal: this.controller.signal,
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })

      .then((response) => {
        let dupData = [...this.state.libraryData];

        let i = dupData?.findIndex((x) => x?.CourseId === this.state.editId);
        if (i > -1) {
          dupData[i].Active = this.state.switchCheck;
          dupData[i].CourseName = this.state.listViewDataCoursetitle;
          dupData[i].Description = this.state.listViewDataCoursedesc;
          dupData[i].LocationID = this.state.listViewDataCourselocation;
          dupData[i].Venue = this.state.listViewDataCoursevenue;
          dupData[i].CPDTypeId = this.state.listViewDataCoursetype;
          dupData[i].CPDFormatId = this.state.listViewDataCourseformat;
          dupData[i].HostID = this.state.listViewDataCoursehost;
          dupData[i].Trainer = this.state.listViewDataCoursetrainer;
          dupData[i].SurveyLink = this.state.listViewDataSurveyLink;
          dupData[i].StartDate = this.state.listViewDataCoursestartdate;
          dupData[i].DurationHours = this.state.listViewDataCoursecpdhours;
          dupData[i].HowToBook = this.state.listViewDataCoursehowtobook;
          dupData[i].DurationMins = this.state.listViewDataCoursecpdMinutes;

          NotificationManager.success(
            response?.data.CourseName,
            'Course updated successfully!'
          );

          this.setState({
            libraryData: dupData,
            addEditCoursebtn: false,
            listViewModalShown: false,
            listViewDataCoursetitle: '',
            listViewDataCoursedesc: '',
            listViewDataCourselocation: '',
            listViewDataCoursevenue: '',
            listViewDataCoursetype: '',
            listViewDataCourseformat: '',
            listViewDataCoursehost: '',
            listViewDataCoursetrainer: '',
            listViewDataSurveyLink: '',
            listViewDataCoursestartdate: '',
            listViewDataCoursecpdhours: '',
            listViewDataCoursehowtobook: '',
            listViewDataCoursecpdMinutes: '',
          });
          this.searchData();
        }
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  handleFile(e) {}

  handleUploadFile() {
    let data = new FormData();

    data.append('file', this.state.file);

    if (!this.state.file) {
      return NotificationManager.error('File not Selected');
    }

    axios
      .post(upload_Course_Url, data, {
        withCredentials: true,
        credentials: 'include',
        signal: this.controller.signal,
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
          courseid: this.state.editId,
        },
      })

      .then((response) => {
        this.setState({ fileData: response?.data });

        NotificationManager.success('File uploaded Successfully!');
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  handleDeleteFile(feild_id, Course_id) {
    axios
      .get(delete_Url, {
        params: {
          fileId: feild_id,
          courseId: Course_id,
        },
        method: 'GET',
        withCredentials: true,
        credentials: 'include',
        signal: this.controller.signal,
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        let dupdata = [...this.state.fileData];
        let filt = dupdata.filter((x) => x.ID !== feild_id);
        this.setState({
          fileData: filt,
        });
      })

      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }
  handleDownloadFile(id) {
    let dup = [...this.state.fileData];
    let findData = dup.find((x) => x.ID === id);

    axios
      .get(downloadFile_Url, {
        params: {
          name: findData?.ModifiedFileName,
        },
        method: 'GET',
        withCredentials: true,
        credentials: 'include',
        signal: this.controller.signal,
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        var blob = new Blob([response.data]);

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, findData?.ModifiedFileName);
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', findData?.ModifiedFileName);
          document.body.appendChild(link);
          link.click();
        }
      });
  }

  onSort = (column) => (e) => {
    const direction = this.state.sort.column
      ? this.state.sort.direction === 'asc'
        ? 'desc'
        : 'asc'
      : 'desc';
    this.setState({
      sort: {
        column,
        direction,
      },
    });
    let pages = this.state.activePage;
    let CPDTypeId = this.state.cpd_type;
    let CourseName = this.state.course_name;
    let HostId = this.state.host_name;
    let LocationName = this.state.location_name;
    this.getLibraryData(
      pages,
      CPDTypeId,
      CourseName,
      HostId,
      LocationName,
      column,
      direction
    );
  };

  setArrow = (column) => {
    let className = 'fa fa-sort';
    if (this.state.sort.column === column) {
      className += this.state.sort.direction === 'asc' ? '-asc' : '-desc';
    }
    return className;
  };

  componentWillUnmount() {
    this.controller.abort();
  }

  render() {
    let listViewModalShownClose = () =>
      this.setState({ listViewModalShown: false, addEditCoursebtn: false });
    let libraryData;

    if (this?.state?.libraryData !== null) {
      libraryData = this?.state?.libraryData?.map((libraryItem, index) => {
        return (
          <tr key={index}>
            <td>{libraryItem?.CourseName}</td>
            <td>{libraryItem?.Expr1}</td>
            <td>{libraryItem?.hostName}</td>
            <td>{libraryItem?.Venue}</td>
            <td>
              {libraryItem?.DurationHours}h{' '}
              {libraryItem?.DurationMins ? `${libraryItem?.DurationMins}m` : ''}
            </td>

            <td>{libraryItem?.Description}</td>
            <td>
              {libraryItem?.StartDate
                ? moment(libraryItem?.StartDate).format('ll')
                : 'na'}
            </td>
            <td>
              <button
                onClick={() => this.editCourse(libraryItem.CourseId)}
                className="button-custom"
              >
                <i className="fa fa-pencil icon-tables"> </i>
              </button>
            </td>
            <td>
              {libraryItem.Active === true ? (
                <button
                  className="button-custom"
                  onClick={() => this.archiveCourse(libraryItem.CourseId)}
                >
                  <i className="fa fa-file-archive-o icon-tables"> </i>
                </button>
              ) : (
                <button
                  className="button-custom"
                  onClick={() => this.unarchiveCourse(libraryItem.CourseId)}
                >
                  <i className="fa fa-flickr icon-tables"> </i>
                </button>
              )}
            </td>
          </tr>
        );
      });
    }

    return (
      <div>
        {this.state.mainLoading && <LinearProgress id="main-loader" />}
        <div>
          <div className="panel panel-default">
            <div className="panel-heading-cpd-3" style={{ padding: '10px' }}>
              <i
                className="fa fa-filter "
                title=""
                data-original-title="Search"
              >
                {' '}
                Search
              </i>
            </div>
            <div className="shadow">
              <div className="layout-gt-sm-row">
                <div style={{ padding: '1rem 1rem' }}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group admin-forms">
                        <label>Course name</label>
                        <input
                          type="Course name"
                          className="form-control"
                          id="Course name"
                          onChange={(e) =>
                            this.setState({ course_name: e.target.value })
                          }
                          value={this.state.course_name}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              this.searchData();
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group admin-forms">
                        <label>Location name</label>

                        <input
                          type="Location name"
                          className="form-control"
                          id="Location name"
                          value={this.state.location_name}
                          onChange={(e) =>
                            this.setState({ location_name: e.target.value })
                          }
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              this.searchData();
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group admin-forms">
                        <label>CPD Type</label>
                        <select
                          value={this.state.cpd_type}
                          className="form-control"
                          id="sel1"
                          onChange={(e) =>
                            this.setState({ cpd_type: e.target.value })
                          }
                        >
                          <option value="" disabled hidden></option>
                          {this.state.cpdType.length &&
                            this.state?.cpdType?.map((item, index) => {
                              return (
                                <option key={index} value={item.CPDTypeId}>
                                  {item.Description}
                                </option>
                              );
                            })}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group date admin-forms">
                        <label>Enter Start Date</label>

                        <input
                          type="date"
                          placeholder=""
                          className="form-control"
                          value={this.state.start_date}
                          onChange={(e) =>
                            this.setState({ start_date: e.target.value })
                          }
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group admin-forms">
                        <label>Host</label>
                        <select
                          className="form-control"
                          id="sel1"
                          value={this.state.host_name}
                          onChange={(e) =>
                            this.setState({ host_name: e.target.value })
                          }
                        >
                          <option value="" disabled hidden></option>
                          {this?.state?.loadHost?.length &&
                            this?.state?.loadHost?.map((item, index) => {
                              return (
                                <option key={index} value={item?.ID}>
                                  {item?.Name}
                                </option>
                              );
                            })}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div>
                    <button
                      className="btn btn-primary"
                      style={{ marginRight: '10px' }}
                      onClick={this.searchData}
                    >
                      <span className="glyphicon glyphicon-search"> </span>{' '}
                      Search
                    </button>
                    <button
                      className="btn btn-primary"
                      onClick={this.clearSearchFilters}
                    >
                      <span className="glyphicon glyphicon-remove-sign"> </span>{' '}
                      Clear
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="gridTopButtons">
            <button
              type="button"
              onClick={() => window.print()}
              className="btn btn-danger btn-circle btn-lg "
            >
              <i className="fa fa-print"> </i>
            </button>

            <button
              type="button"
              className="btn btn-warning btn-circle btn-lg"
              style={{ marginLeft: '10px' }}
              onClick={this.pdfDownload}
            >
              <i className="fa fa-download"></i>
            </button>

            <button
              className="btn btn-success btn-circle btn-lg"
              style={{ marginLeft: '10px' }}
              onClick={this.downloadExcel}
            >
              <i className="fa fa-file-pdf-o"> </i>
            </button>

            <button
              type="button"
              style={{ marginLeft: '10px' }}
              className="btn btn-primary btn-circle btn-lg ng-scope"
              data-original-title=""
              title=""
              onClick={this.modalData}
            >
              <i style={{ color: 'white' }} className="fa fa-plus">
                {' '}
              </i>
            </button>
          </div>
        </div>
        <div className="col-table">
          {this.state.mainLoading && <Loader />}
          <table className="table table-striped table-bordered table-hover table-condensed">
            <thead>
              <tr className="header">
                <th onClick={this.onSort('CourseName')}>
                  Course Name <i className={this.setArrow('CourseName')}> </i>
                </th>
                <th onClick={this.onSort('Expr1')}>
                  Location <i className={this.setArrow('Expr1')}> </i>
                </th>
                <th onClick={this.onSort('Name')}>
                  Host <i className={this.setArrow('Name')}> </i>
                </th>
                <th onClick={this.onSort('Venue')}>
                  Venue <i className={this.setArrow('Venue')}> </i>
                </th>
                <th onClick={this.onSort('DurationHours')}>
                  Duration <i className={this.setArrow('DurationHours')}> </i>
                </th>
                <th onClick={this.onSort('Description')}>
                  Type <i className={this.setArrow('Description')}> </i>
                </th>
                <th onClick={this.onSort('StartDate')}>
                  Start Date <i className={this.setArrow('StartDate')}> </i>
                </th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>{libraryData}</tbody>
          </table>
          {libraryData.length > 0 ? '' : this.state.emptyDivMsg}
          <div></div>
        </div>
        <Pagination
          prevPageText="Previous"
          nextPageText="Next"
          firstPageText="First"
          lastPageText="Last"
          activePage={this.state.activePage}
          itemsCountPerPage={this.state.per_page}
          totalItemsCount={this.state.totalCount}
          onChange={this.handlePageChange}
        />
        <ViewModal
          show={this.state.listViewModalShown}
          data={this.state}
          host={this.state.loadHost}
          cpd_Handle_Type={this.state.cpdType}
          coursetitle={this.state.listViewDataCoursetitle}
          coursedesc={this.state.listViewDataCoursedesc}
          courselocation={this.state.listViewDataCourselocation}
          coursevenue={this.state.listViewDataCoursevenue}
          coursetype={this.state.listViewDataCoursetype}
          courseformat={this.state.listViewDataCourseformat}
          coursehost={this.state.listViewDataCoursehost}
          coursetrainer={this.state.listViewDataCoursetrainer}
          coursesurveylink={this.state.listViewDataSurveyLink}
          coursestartdate={this.state.listViewDataCoursestartdate}
          coursecpdhour={this.state.listViewDataCoursecpdhours}
          coursebook={this.state.listViewDataCoursehowtobook}
          coursemin={this.state.listViewDataCoursecpdMinutes}
          addeditcoursebtn={this.state.addEditCourseBtn}
          switchCheck={this.state.switchCheck}
          filesData={this?.state?.fileData}
          inHouse={this.state.listViewInHouseOnly}
          adminActive={this.state.listViewAdminOnly}
          handleuploadfile={this.handleUploadFile}
          onHide={listViewModalShownClose}
          handleUpdateData={this.handleUpdateData}
          handleTitleChange={this.handleTitleChange}
          handleDescChange={this.handleDescChange}
          handleLocChange={this.handleLocChange}
          handleVenueChange={this.handleVenueChange}
          handleTypeChange={this.handleTypeChange}
          handleFormatChange={this.handleFormatChange}
          handleHostChange={this.handleHostChange}
          handleTrainerChange={this.handleTrainerChange}
          handleSurveyLinkChange={this.handleSurveyLinkChange}
          handleStartDateChange={this.handleStartDateChange}
          handleCpdHourChange={this.handleCpdHourChange}
          handleCourseBookChange={this.handleCourseBookChange}
          handleCpdMinutesChange={this.handleCpdMinutesChange}
          cpd_format={this.state.cpd_format}
          course_Location={this.state.course_Location}
          handleAddData={this.handleAddData}
          handleSwitchButton={this.handleSwitchButton}
          file={(e) => this.setState({ file: e })}
          handleDeleteFile={this.handleDeleteFile}
          handleDownloadFile={this.handleDownloadFile}
          listViewAdminOnly={(e) => this.setState({ listViewAdminOnly: e })}
          listViewInHouseOnly={(e) => this.setState({ listViewInHouseOnly: e })}
          titlemodal={this.state.titlemodal}
          paymentneeded={this.state.listViewDataPaymentNeeded}
          handlePaymentNeededChange={this.handlePaymentNeededChange}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    signOut: () => dispatch(removeData()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminDash);
